"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setStoredLang = exports.getStoredLang = exports.default = exports.STORED_LANG_KEY = exports.POUND = exports.MILLIGRAMS_PER_DECILITRE = exports.KILOGRAM = exports.INCH = exports.FOOT = exports.DEFAULT_LANG = exports.CODES = exports.CENTIMETER = void 0;
var _storage = _interopRequireDefault(require("@livongo/utilities/system/storage"));
var _locales = _interopRequireDefault(require("./locales"));
/*
   Adding a new country and/or language? Follow these steps:

   1) add the country's code to COUNTRIES array
   2) add the country's language codes to the LANGUAGES array
   3) add the proper date-fns date locale to the DATE_LOCALES object with the language code as the keyname
   4) add the proper data to the UNITS object with the country code as the keyname
   5) go to /locales dir, make a new dir with the language codes, and make a file named index.json
   6) go into smartling and add support for new language codes
   7) raise a PR, wait for Smartling action to finish, merge smartling then merge your PR
*/

// Array of country codes
const COUNTRIES = ['CA', 'ES', 'GB', 'FR', 'US'];
// Array of language codes
const LANGUAGES = ['en-CA', 'en-GB', 'en-US', 'es-ES', 'es-US', 'fr-CA', 'fr-FR'];

// default to send to i18n
const DEFAULT_LANG = exports.DEFAULT_LANG = 'en-US';
// key that stores language preferance
const STORED_LANG_KEY = exports.STORED_LANG_KEY = 'livongo-i18n-lang';
// get stored language preferance
const getStoredLang = () => {
  return _storage.default.get({
    key: STORED_LANG_KEY
  }) || DEFAULT_LANG;
};
// store language preferance
exports.getStoredLang = getStoredLang;
const setStoredLang = value => {
  return _storage.default.set({
    key: STORED_LANG_KEY,
    value
  });
};

// object with key names based on individual language codes
// all data comes directly from date-fns package
exports.setStoredLang = setStoredLang;
const DATE_LOCALES = {
  'en-CA': require('date-fns/locale/en-CA').default,
  'en-GB': require('date-fns/locale/en-GB').default,
  'en-US': require('date-fns/locale/en-US').default,
  'es-ES': require('date-fns/locale/es').default,
  'fr-CA': require('date-fns/locale/fr-CA').default,
  'fr-FR': require('date-fns/locale/fr').default,
  // date-fns does not have locales as specific as this language code
  // use a getter to return the same as  the es-ES keyname
  get 'es-US'() {
    return this['es-ES'];
  }
};

// length constants
const FOOT = exports.FOOT = 'ft';
const INCH = exports.INCH = 'in';
const CENTIMETER = exports.CENTIMETER = 'cm';
// weight constants
const POUND = exports.POUND = 'lb';
const KILOGRAM = exports.KILOGRAM = 'kg';
// volume constants
const MILLIGRAMS_PER_DECILITRE = exports.MILLIGRAMS_PER_DECILITRE = 'mg/dL';
const display = types => types.join(', ');

// Arrow function with switch condition depends on an individual country code
// booleans for the project to do logic off
const UNITS = code => {
  switch (code) {
    case 'US':
      return {
        length: {
          get display() {
            return display(this.types);
          },
          types: [FOOT, INCH],
          hasFeet: true,
          hasInches: true,
          hasCentimeters: false
        },
        weight: {
          get display() {
            return display(this.types);
          },
          types: [POUND],
          hasPounds: true,
          hasKilograms: false
        },
        glucose: {
          get display() {
            return display(this.types);
          },
          types: [MILLIGRAMS_PER_DECILITRE],
          hasMilligramsPerDecilitre: true
        }
      };
    case 'CA':
    case 'GB':
    case 'ES':
    case 'FR':
      return {
        length: {
          get display() {
            return display(this.types);
          },
          types: [CENTIMETER],
          hasFeet: false,
          hasInches: false,
          hasCentimeters: true
        },
        weight: {
          get display() {
            return display(this.types);
          },
          types: [KILOGRAM],
          hasPounds: false,
          hasKilograms: true
        },
        glucose: {
          get display() {
            return display(this.types);
          },
          types: [MILLIGRAMS_PER_DECILITRE],
          hasMilligramsPerDecilitre: true
        }
      };
    default:
      throw new Error("React-Pulse-SDK doesn't support ".concat(code, " country units"));
  }
};
const CODES = exports.CODES = {
  COUNTRIES,
  LANGUAGES
};
var _default = exports.default = COUNTRIES.map(code => ({
  code,
  languages: LANGUAGES.filter(lang => lang.slice(3) === code).map(lang => ({
    code: lang,
    // date-fns locale object for language code
    date: DATE_LOCALES[lang],
    // language files for ui repo for language code
    i18n: _locales.default[lang]
  })),
  units: UNITS(code)
}));